function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M5.665 7.5l3.7 1.83a1.132 1.132 0 01-.486 1.935c-.464.116-.95.083-1.391-.09l-.186-.083-3.078-1.54-.084-.032a.5.5 0 00-.44.88l.076.047 3.078 1.54.214.097a3.286 3.286 0 002.053.151 2.132 2.132 0 001.444-2.905l3.403-1.444a1.458 1.458 0 011.736.467l.08.118.065.12a1.475 1.475 0 01-.538 1.898l-.123.068-.246.133-.83.484-.902.54a14.708 14.708 0 01-3.115 1.412l-.47.141-1.894.536a5.206 5.206 0 01-2.956-.036l-.18-.056-.178-.056-.678-.219-.628-.213-.579-.208c-.913-.337-1.624-.652-2.136-.945l-.163-.098-.226-.14v-.416L0 10.26l.005-.127.03-.257c.181-1.207.85-2.003 1.957-2.315l.2-.05.102-.011h3.371zM11.4 2c.884 0 1.6.64 1.6 1.429 0 .766 0 1.526-2.75 3.403L10 7C7.171 5.114 7.01 4.31 7 3.564v-.135C7 2.639 7.716 2 8.6 2c.403 0 .939.252 1.401.602.461-.35.996-.602 1.399-.602z"
});

var SvgCharity = function SvgCharity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCharity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Charity.22ea359a.svg";
export { ForwardRef as ReactComponent };